import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MiscSvgComponent } from '@curbnturf/custom-svgs/src/lib/misc-svg/misc-svg.component';
import { SiteSvgsComponent } from '@curbnturf/custom-svgs/src/lib/site-svgs/site-svgs.component';
import { ActivityType, IActivity } from '@curbnturf/entities';

@Component({
  selector: 'curbnturf-activity-display',
  templateUrl: './activity-display.component.html',
  styleUrls: ['./activity-display.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, NgClass, SiteSvgsComponent, MiscSvgComponent],
})
export class ActivityDisplayComponent {
  @Input() activities: IActivity[];

  activityType = ActivityType;

  openDescriptions: { [index: number]: boolean } = {};

  toggleDescription(index: number) {
    this.openDescriptions[index] = !this.openDescriptions[index];
  }
  name(activity: IActivity): string {
    if (activity && activity.type && (activity.type as string) === 'custom') {
      return activity.typeCustom || '';
    }

    if (activity.type) {
      return this.activityType[activity.type];
    }

    return '';
  }
}
